import { JdPokerComponent } from "./jd_poker_component";
import { JdDealCardsEffect } from "./jd_deal_cards_effect";
import JdSidePotEffect from "./jd_sidePot_effect";
import { SeatState } from "../../../../texasholdem/module/table/component/seat_state_component";
import { HandCardEffect } from "./jd_handcard_effect";
import TexasAnimEffect from "../../../../texasholdem/module/table/component/texas_animation_effect";
import { PokerCommonColor } from "../../../../k9/module/table/component/poker_com_color";


//牌桌UI
const {ccclass, property} = cc._decorator;

@ccclass
export class JdTableViewComponent extends cc.Component {

    seatState:SeatState[] = [];

    @property(cc.Node)
    seatPrefab:cc.Node = null;

    @property(cc.Node)
    seatPlayerPrefab:cc.Node = null;

    @property(cc.Node)
    pokerPrefab:cc.Node = null;

    @property(cc.Node)
    dealer:cc.Node = null;

    @property(cc.Label)
    blindsLab:cc.Label = null;

    @property(cc.Label)
    roomLab:cc.Label = null;

    @property([PokerCommonColor])
    meHands:PokerCommonColor[] = [];

    @property(cc.Node)
    mhandNode:cc.Node = null;

    @property(cc.Node)
    potRoot:cc.Node = null;
    //手动增加金币
    @property(cc.Node)
    addBet:cc.Node = null;

    @property(cc.Node)
    heguan:cc.Node = null;

    @property(cc.Node)//发牌点
    dealerNode:cc.Node = null;

    @property(cc.Node)
    mySelfPoker:cc.Node = null;

    @property([JdDealCardsEffect])
    twoCardsEffect:JdDealCardsEffect[] = [];

    //归池终点
    @property(cc.Node)
    checkBetNode:cc.Node = null;

    @property(cc.Node)
    mainNode:cc.Node = null;

    @property(JdSidePotEffect)
    sidePool:JdSidePotEffect = null;

    @property(cc.Node)
    maxCardsDes: cc.Node = null;//最大牌型描述

    @property(cc.Node)
    patternCard:cc.Node = null;

    @property(cc.Node)//我方牌型
    myTypeNode:cc.Node = null;   
    
    @property(cc.Node)
    countDownNode:cc.Node = null;

    @property(cc.Node)
    chatNode:cc.Node = null;

    @property(cc.Node)
    cardPattern:cc.Node = null;

    @property(cc.Node)
    patternMask:cc.Node = null;

    @property(HandCardEffect)
    handEffect:HandCardEffect = null;

    @property(TexasAnimEffect)
    addAnim:TexasAnimEffect = null;

    @property(cc.Node)
    pokerControl:cc.Node = null;

    //设置座位人数
    setSeatNumb(numb:number){
        let seatSetting = 'Seat_' + numb;
        let seat = this.node.getChildByName(seatSetting);
        this.seatState.length = 0;
        if (seat) {
            for (let seatSetting of seat.children) {
                let info = seatSetting.getComponent(SeatState);
                this.seatState.push(info);
            }
        }else{
            cc.error('座位人数错误!',numb);
        }
    }
}
